

import React, { Component } from 'react'
import Overlay from "../Overlay";
import Select from "react-select";
import { showModalNoOutsideClick, getLabel, getReactSelectAriaLabel, getLabelsForMultiSelect, getReactSelectAriaLabelMultiselect } from "../../util/FormatUtil";
import SystemAPI from "../../network/SystemAPI";
import ChildInfoModal from '../modals/ChildInfoModal';
import ParentInfoModal from '../modals/ParentInfoModal';
import SchoolInfoModal from '../modals/SchoolInfoModal';
import Acknowledgement from './Acknowledgement';
import Validator from "../../validation/Validator";
import { Validators } from "../../validation/Validators";
import { sweetalert } from "../../App";
import ExemptionAPI from '../../network/ExemptionAPI';
import SubmissionFileUploadModal from '../modals/SubmissionFileUploadModal';
import { withTranslation } from 'react-i18next';
import PhysicianInfoModal from '../modals/PhysicianInfoModal';


// Define the type for a facility object (schools and childcares are now stored in the Facility table)
interface Facility {
  ID: number;
  FacilityName: string;
  SchoolDistrictID?: number;
}


class VaccineExemptions extends Component<any, any> {


  private submissionFileRef: any;



  constructor(props) {
    super(props)
    this.state = {
      states: [],
      countries: [],
      ethnicities: [],
      genders: [],
      races: [],
      ExemptionType: "",
      exemptionOptions: [
        { label: "Medical Exemption", value: 1 },
        { label: "Religious Objection", value: 2 },
        { label: "Personal Objection", value: 3 }
      ],
      ExemptImmunizations: "",
      ObjectionSummary: "",
      childInfo: {},
      parentInfo: {},
      schoolInfo: {},
      childInfoSaved: false,
      parentInfoSaved: false,
      schoolInfoSaved: false,
      acknowledged: false,
      counties: [],
      duplicateCheckPassed: false,
      duplicateOverridden: false,
      schools: [],
      childCareFacilities: [],
      schoolDistricts: [],
    }
    this.submissionFileRef = React.createRef();
  }

  componentDidMount(): void {

    document.title = 'Submit Vaccine Exemptions | Oklahoma Department of Health';

    this.setState({ showLoading: true });

    const apiCalls = [
      SystemAPI.getAllStates().then(data => this.setState({ states: data })),
      SystemAPI.getAllSchoolDistricts().then(data => this.setState({ schoolDistricts: data })),
      SystemAPI.getFacilitySchools().then(data => this.setState({ schools: data })),
      SystemAPI.getFacilityChildcares().then(data => this.setState({ childCareFacilities: data })),
      SystemAPI.getAllCountries().then(data => this.setState({ countries: data })),
      SystemAPI.getAllEthnicities().then(data => this.setState({ ethnicities: data })),
      SystemAPI.getAllGenders().then(data => this.setState({ genders: data })),
      SystemAPI.getAllRaces().then(data => this.setState({ races: data })),
      SystemAPI.getAllImmunizations().then(data => {
        let arrayWithAllSelection = [{ label: "All", value: 0 }].concat(data as { label: string; value: number; }[])
        this.setState({ immunizations: data, immunizationOptions: arrayWithAllSelection })
      }),
      SystemAPI.getAllExemptionTypes().then(data => this.setState({ exemptionTypes: data })),
      SystemAPI.getAllPersonalExemptionReasons().then(data => this.setState({ exemptionReasons: data })),
      SystemAPI.getAllCounties().then(response => {
        let allCountyData = response.counties;
        if (allCountyData && allCountyData.length > 0) {
          allCountyData = allCountyData.map((county) => {
            return { label: county.County, value: county.State };
          });
        }
        this.setState({ counties: allCountyData });
      })
    ];

    Promise.all(apiCalls)
      .catch(() => {
        sweetalert.fire({ icon: 'error', title: '', text: 'Failed to load form data. Please refresh the page and try again.' });
      })
      .finally(() => {
        this.setState({ showLoading: false });
      })
  }

  validateForm(exemptionInfoCopy) {

    let exemptionFormValidation = {
      ExemptionReason: exemptionInfoCopy.ExemptionReason,
      ObjectionSummary: exemptionInfoCopy.ObjectionSummary,
      ExemptImmunizations: exemptionInfoCopy.ExemptImmunizations.length ? exemptionInfoCopy.ExemptImmunizations : null,
    };

    if (!exemptionInfoCopy.ExemptionType) {
      return { success: false, error: this.props.t("You must select an Exemption Type") }
    }
    if (this.state.ExemptionType === 5 && !this.state.physicianInfoSaved) {
      return { success: false, error: this.props.t("You must complete physician information") }
    }
    // physicianInfoSaved only records that the modal was saved. The file is checked
    // separately so a rejected replacement cannot leave the submission with no form.
    if (this.state.ExemptionType === 5 && !this.state.ApprovalLetter) {
      return { success: false, error: this.props.t("Please upload the Medical Exemption Request Form") }
    }
    if (!this.state.childInfoSaved) {
      return { success: false, error: this.props.t("You must complete child information") }
    }
    if (!this.state.parentInfoSaved) {
      return { success: false, error: this.props.t("You must complete parent information") }
    }
    if (!this.state.schoolInfoSaved) {
      return { success: false, error: this.props.t("You must complete school information") }
    }
    if (!exemptionInfoCopy.acknowledged) {
      return { success: false, error: this.props.t("You must acknowledge all policies listed in this form") }
    }


    let validator;
    if (exemptionInfoCopy.ExemptionType === 5) {
      validator = new Validator<any>()
        .withSimpleValidation("ExemptImmunizations", Validators.requireNonNullValidator("Exempt immunizations"))
    } else if (exemptionInfoCopy.ExemptionType === 2) {
      validator = new Validator<any>()
        .withSimpleValidation("ExemptImmunizations", Validators.requireNonNullValidator("Exempt immunizations filed"))
    } else if (exemptionInfoCopy.ExemptionType === 1) {
      validator = new Validator<any>()
        .withSimpleValidation("ExemptImmunizations", Validators.requireNonNullValidator("Exempt immunizations filed"))
        .withSimpleValidation("ExemptionReason", Validators.requireNonNullValidator("Exemption Reason"))
      if (exemptionInfoCopy.ExemptionReason === 7) {
        validator = new Validator<any>()
          .withSimpleValidation("ObjectionSummary", Validators.requireNonNullValidator("Objection Summary"))
      }
    }



    let validationResponse = validator.validate(exemptionFormValidation);
    if (!validationResponse.success) {
      return { success: false, error: validationResponse.error }
    } else {
      return { success: true }
    }



  }

  // Accepts a change event, a File, or null. Null is used by the modal to drop a
  // previously accepted file when a newer selection is rejected, so this state can
  // never hold a file the parent has since replaced.
  onUpload = (state, e) => {
    if (e && e.target) {
      this.setState({ [state]: e.target.files[0] } as any)
    }
    else {
      this.setState({ [state]: e } as any)
    }
  }

  escapeHtml(str: string): string {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  getExemptionTypeLabel(typeValue: number): string {
    const types = {
      1: 'Personal Objection',
      2: 'Religious Objection',
      3: 'Other',
      4: 'Patient Decision',
      5: 'Medical Exemption'
    };
    // Try to get from loaded exemption types first, fall back to hardcoded map
    if (this.state.exemptionTypes) {
      const found = this.state.exemptionTypes.find((t: any) => t.value === typeValue);
      if (found) return found.label;
    }
    return types[typeValue] || 'Unknown';
  }

  getStatusLabel(status: any): string {
    if (status === 1) return 'Approved';
    if (status === 0) return 'Denied';
    return 'Pending';
  }

  formatDate(dateStr: any): string {
    if (!dateStr) return 'N/A';
    // Parse as UTC to avoid timezone offset shifting the date by a day.
    // MySQL DATETIME values come back without timezone info, and new Date()
    // can interpret them in local time, causing off-by-one day errors.
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
  }

  /**
   * Triggers the duplicate check when both child info and exemption type are available.
   * Called from: (1) child info modal submit callback, (2) exemption type dropdown onChange.
   * Shows a warning modal immediately if a match is found, before the user fills out the rest of the form.
   */
  async triggerDuplicateCheck(childInfo?: any, exemptionType?: number) {
    const child = childInfo || this.state.childInfo;
    const type = exemptionType || this.state.ExemptionType;

    // Both pieces of info are needed
    if (!child?.ChildFirstName || !child?.ChildLastName || !child?.ChildDOB || !type) {
      return;
    }

    // Reset duplicate state since inputs changed
    this.setState({ duplicateCheckPassed: false, duplicateOverridden: false });

    try {
      const duplicateCheck = await ExemptionAPI.checkDuplicate(
        child.ChildFirstName,
        child.ChildLastName,
        child.ChildDOB,
        type
      );

      if (!duplicateCheck.success) {
        this.setState({ duplicateCheckPassed: true }); // Fail-open
        return;
      }

      if (duplicateCheck.status === 'exact_match') {
        const existing = duplicateCheck.existing;
        const result = await sweetalert.fire({
          icon: 'warning',
          title: this.props.t('Duplicate Exemption Found'),
          html: `<div style="text-align: left;">
            <p>${this.props.t('An exemption of this type already exists for this child.')}</p>
            <table style="width: 100%; margin-bottom: 12px; border-collapse: collapse;">
              <tr><td style="padding: 4px 8px; font-weight: bold; white-space: nowrap; vertical-align: top;">${this.props.t('Child')}</td><td style="padding: 4px 8px;">${this.escapeHtml(existing.childFirstName)} ${this.escapeHtml(existing.childLastName)}</td></tr>
              <tr><td style="padding: 4px 8px; font-weight: bold; white-space: nowrap; vertical-align: top;">${this.props.t('Date of Birth')}</td><td style="padding: 4px 8px;">${this.escapeHtml(this.formatDate(existing.childDOB))}</td></tr>
              <tr><td style="padding: 4px 8px; font-weight: bold; white-space: nowrap; vertical-align: top;">${this.props.t('Exemption Type')}</td><td style="padding: 4px 8px;">${this.escapeHtml(this.props.t(this.getExemptionTypeLabel(existing.exemptionType)))}</td></tr>
              <tr><td style="padding: 4px 8px; font-weight: bold; white-space: nowrap; vertical-align: top;">${this.props.t('Status')}</td><td style="padding: 4px 8px;">${this.escapeHtml(this.props.t(this.getStatusLabel(existing.status)))}</td></tr>
              <tr><td style="padding: 4px 8px; font-weight: bold; white-space: nowrap; vertical-align: top;">${this.props.t('Submitted')}</td><td style="padding: 4px 8px;">${this.escapeHtml(this.formatDate(existing.createdDate))}</td></tr>
              <tr><td style="padding: 4px 8px; font-weight: bold; white-space: nowrap; vertical-align: top;">${this.props.t('Confirmation #')}</td><td style="padding: 4px 8px;">${this.escapeHtml(existing.reqNum)}</td></tr>
            </table>
            <p>${this.props.t('If you believe this is a different child or a new request, you may proceed.')}</p>
            <hr/>
            <p><strong>${this.props.t('Need to correct a previous submission?')}</strong></p>
            <p>${this.props.t('If you previously submitted an exemption with incorrect information (such as a misspelled name or wrong date of birth), please do not submit a new exemption. Instead, contact OSDH to have your existing submission corrected.')}</p>
            <ul style="list-style: none; padding-left: 0;">
              <li><strong>${this.props.t('Phone')}:</strong> (405) 426-8580</li>
              <li><strong>${this.props.t('Email')}:</strong> IMM.Exemption@health.ok.gov</li>
            </ul>
          </div>`,
          showCancelButton: true,
          confirmButtonText: this.props.t('Proceed Anyway'),
          cancelButtonText: this.props.t('Cancel'),
        });

        this.setState({
          duplicateCheckPassed: result.isConfirmed,
          duplicateOverridden: result.isConfirmed
        });
        return;
      }

      if (duplicateCheck.status === 'possible_match') {
        const candidate = duplicateCheck.candidates[0];
        const result = await sweetalert.fire({
          icon: 'warning',
          title: this.props.t('Similar Record Found'),
          html: `<div style="text-align: left;">
            <p>${this.props.t('We found a similar record that may be for the same child.')}</p>
            <table style="width: 100%; margin-bottom: 12px; border-collapse: collapse;">
              <tr><td style="padding: 4px 8px;"></td><td style="padding: 4px 8px; font-weight: bold;">${this.props.t('Existing Record')}</td><td style="padding: 4px 8px; font-weight: bold;">${this.props.t('Your Entry')}</td></tr>
              <tr><td style="padding: 4px 8px; font-weight: bold; white-space: nowrap;">${this.props.t('Child')}</td><td style="padding: 4px 8px;">${this.escapeHtml(candidate.childFirstName)} ${this.escapeHtml(candidate.childLastName)}</td><td style="padding: 4px 8px;">${this.escapeHtml(child.ChildFirstName)} ${this.escapeHtml(child.ChildLastName)}</td></tr>
              <tr><td style="padding: 4px 8px; font-weight: bold; white-space: nowrap;">${this.props.t('Date of Birth')}</td><td style="padding: 4px 8px;">${this.escapeHtml(this.formatDate(candidate.childDOB))}</td><td style="padding: 4px 8px;">${this.escapeHtml(this.formatDate(child.ChildDOB))}</td></tr>
              <tr><td style="padding: 4px 8px; font-weight: bold; white-space: nowrap;">${this.props.t('Confirmation #')}</td><td style="padding: 4px 8px;">${this.escapeHtml(candidate.reqNum)}</td><td style="padding: 4px 8px;">—</td></tr>
            </table>
            <hr/>
            <p><strong>${this.props.t('Need to correct a previous submission?')}</strong></p>
            <p>${this.props.t('If you previously submitted an exemption with incorrect information (such as a misspelled name or wrong date of birth), please do not submit a new exemption. Instead, contact OSDH to have your existing submission corrected.')}</p>
            <ul style="list-style: none; padding-left: 0;">
              <li><strong>${this.props.t('Phone')}:</strong> (405) 426-8580</li>
              <li><strong>${this.props.t('Email')}:</strong> IMM.Exemption@health.ok.gov</li>
            </ul>
          </div>`,
          showCancelButton: true,
          confirmButtonText: this.props.t('This is a different child - continue'),
          cancelButtonText: this.props.t('Cancel'),
        });

        this.setState({
          duplicateCheckPassed: result.isConfirmed,
          duplicateOverridden: result.isConfirmed
        });
        return;
      }

      // status === 'clear' — no duplicates found
      this.setState({ duplicateCheckPassed: true, duplicateOverridden: false });
    } catch (error) {
      console.error('Error checking for duplicates:', error);
      this.setState({ duplicateCheckPassed: true }); // Fail-open
    }
  }

  async submitForm() {

    let exemptImmunizationsArray = this.state.ExemptImmunizations ? this.state.ExemptImmunizations.map(obj => obj.value) : [];
    let contraImmunizationsArray = this.state.ContraImmunizations ? this.state.ContraImmunizations.map(obj => obj.value) : [];


    let exemptionInfoCopy = {
      ExemptionType: this.state.ExemptionType ? JSON.parse(JSON.stringify(this.state.ExemptionType)) : null,
      ContraImmunizations: contraImmunizationsArray ? contraImmunizationsArray : null,
      ExemptionReason: this.state.ExemptionReason ? JSON.parse(JSON.stringify(this.state.ExemptionReason)) : null,
      ObjectionSummary: this.state.ObjectionSummary ? JSON.parse(JSON.stringify(this.state.ObjectionSummary)) : null,
      ExemptImmunizations: exemptImmunizationsArray,
      acknowledged: this.state.acknowledged ? JSON.parse(JSON.stringify(this.state.acknowledged)) : null,
      childInfo: this.state.childInfoSaved ? { ...JSON.parse(JSON.stringify(this.state.childInfo)), ChildRaceID: JSON.parse(JSON.stringify(this.state.childInfo.ChildRaceID)) } : null,
      parentInfo: this.state.parentInfoSaved ? JSON.parse(JSON.stringify(this.state.parentInfo)) : null,
      schoolInfo: this.state.schoolInfoSaved ? JSON.parse(JSON.stringify(this.state.schoolInfo)) : null,
      physicianInfo: this.state.physicianInfoSaved ? JSON.parse(JSON.stringify(this.state.physicianInfo)) : null,
    }


    let res = await this.validateForm(exemptionInfoCopy)
    // @ts-ignore
    if (!res.success) {
      this.setState({ showLoading: false })
      return sweetalert.fire({
        icon: "error",
        title: "",
        // @ts-ignore
        text: this.props.t(res.error),
      });
    }

    // If the duplicate check hasn't been run yet (e.g., child info or exemption type
    // was changed after the initial check), run it now as a safety net before submitting.
    if (!this.state.duplicateCheckPassed) {
      await this.triggerDuplicateCheck();
      // Re-check the flag after the async check completes — user may have cancelled
      if (!this.state.duplicateCheckPassed) {
        this.setState({ showLoading: false });
        return;
      }
    }

    let ApprovalLetter = this.state.ApprovalLetter ? this.state.ApprovalLetter : null;
    //pass back to parent
    this.setState({ showLoading: true }, async () => {
      let res = await ExemptionAPI.newExemption(exemptionInfoCopy, ApprovalLetter);
      if (res.success) {
        this.setState({ showLoading: false }, () => {
          this.submissionFileRef.current.clearSubmissionFileModalState();
          sweetalert.fire({
            icon: "success",
            title: "",
            html: `<div style="text-align: left;">
              <p>${this.props.t('Your exemption has been submitted. You will receive an email and text shortly. Your exemption will be reviewed within the next 1-3 business days.')}</p>
              <p><strong>${this.props.t('NOTE: An exemption must be submitted for each child.')}</strong></p>
              <hr/>
              <p>${this.props.t('If you notice an error in your submission (such as a misspelled name or wrong date of birth), please contact OSDH to request a correction. Do not submit a new exemption.')}</p>
              <ul style="list-style: none; padding-left: 0;">
                <li><strong>${this.props.t('Phone')}:</strong> (405) 426-8580</li>
                <li><strong>${this.props.t('Email')}:</strong> IMM.Exemption@health.ok.gov</li>
              </ul>
            </div>`,
          })
            .then((result) => {
              if (result.isConfirmed) {
                // window.location.reload()
                // return to admin per OSDH request
                //@ts-ignore
                window['location'] = '/admin' as unknown as Location;
              }
            });
        })
      } else {
        this.setState({ showLoading: false }, () => {
          // console.log(res)
          // Prefer the server's stable `code`. The prose fallbacks exist only so a
          // cached bundle talking to an older backend still shows a useful message;
          // they can be dropped once this version is fully deployed.
          // `reason` is this repo's usual field, `message` is what this route sends.
          const serverCode = res?.code ? res.code : '';
          const serverText = res?.reason ? res.reason : (res?.message ? res.message : '');
          const sizeLimit = res?.maxUploadLabel ? res.maxUploadLabel : '10MB';

          const isHeic = serverCode === 'UNSUPPORTED_FILE_TYPE_HEIC'
            || (!serverCode && serverText.includes("iPhone HEIC photo"));
          const isUnsupportedType = serverCode === 'UNSUPPORTED_FILE_TYPE'
            || (!serverCode && serverText.includes("not a supported file type"));
          const isTooLarge = serverCode === 'FILE_TOO_LARGE'
            || (!serverCode && serverText.includes("File size exceeds"));
          const isTooManyFiles = serverCode === 'TOO_MANY_FILES';

          if(isHeic){
            return sweetalert.fire({
              icon: "error",
              title: this.props.t("This is an iPhone HEIC photo, which cannot be accepted."),
              text: this.props.t("Open the photo, choose Share, then Save to Files and select JPEG. A PDF or PNG also works."),
            });
          }

          if(isUnsupportedType){
            return sweetalert.fire({
              icon: "error",
              title: this.props.t("This file type is not accepted. Please upload the form as a PDF, JPG, or PNG file."),
              text: this.props.t("If you took a photo with an iPhone it may be a .HEIC file. Open the photo, choose Share, then Save to Files and select JPEG."),
            });
          }

          if(isTooLarge){
            return sweetalert.fire({
              icon: "error",
              // Limit comes from the server so this cannot drift from what is enforced.
              title: this.props.t("File size exceeds the {{limit}} limit. Please upload a smaller file.", { limit: sizeLimit }),
              text: this.props.t("Please try again!"),
            });
          }

          if(isTooManyFiles){
            return sweetalert.fire({
              icon: "error",
              title: this.props.t("Only one file may be uploaded for the Medical Exemption Request Form."),
              text: this.props.t("Please try again!"),
            });
          }

          return sweetalert.fire({
            icon: "error",
            title: this.props.t("Server Error"),
            text: this.props.t("Please try again!"),
          });
        })
      }
    })
  }

  render() {


    let translationExemptionTypes = this.state.exemptionTypes && this.state.exemptionTypes.length > 0 ? this.state.exemptionTypes.map(e => { return { label: this.props.t(e.label), value: e.value } }) : [];
    let translationPersonalExemptionReasons = this.state.exemptionReasons && this.state.exemptionReasons.length > 0 ? this.state.exemptionReasons.map(e => { return { label: this.props.t(e.label), value: e.value } }) : [];

    return (
      <div className="container-fluid  min-vh-100 ">
        <Overlay show_loading={this.state.showLoading} />
        <ChildInfoModal
          states={this.state.states}
          countries={this.state.countries}
          race={this.state.races}
          gender={this.state.genders}
          ethnicity={this.state.ethnicities}
          submit={(data) => { this.setState({ childInfo: data, childInfoSaved: true, duplicateCheckPassed: false }, () => {
            document.getElementById('ChildInfoButton').focus();
            // Trigger duplicate check if exemption type is already selected
            if (this.state.ExemptionType) {
              this.triggerDuplicateCheck(data, this.state.ExemptionType);
            }
          }) }}
          onClose={() => document.getElementById('ChildInfoButton').focus()}
        />
        <ParentInfoModal
          states={this.state.states}
          countries={this.state.countries}
          counties={this.state.counties}
          race={this.state.races}
          gender={this.state.genders}
          ethnicity={this.state.ethnicities}
          submit={(data) => { this.setState({ parentInfo: data, parentInfoSaved: true }, () => document.getElementById('ParentInfoButton').focus()) }}
          onClose={() => document.getElementById('ParentInfoButton').focus()}
        />
        <SchoolInfoModal
          submit={(data) => { this.setState({ schoolInfo: data, schoolInfoSaved: true }, () => document.getElementById('SchoolInfoButton').focus()) }}
          schools={this.state.schools}
          schoolDistricts={this.state.schoolDistricts}
          childCareFacilities={this.state.childCareFacilities}
          childDOB={this.state.childInfo.ChildDOB}
          onClose={() => document.getElementById('SchoolInfoButton').focus()}
        />
        <SubmissionFileUploadModal
          ref={this.submissionFileRef}
          clearParentState={() => this.setState({ submissionFiles: [] })}
          handleSubmit={(e) => this.setState({ submissionFiles: e, savedFileUpload: true })}
        />
        <PhysicianInfoModal
          states={this.state.states}
          countries={this.state.countries}
          submit={(data) => { this.setState({ physicianInfo: data, physicianInfoSaved: true }, () => document.getElementById('PhysicianInfoButton').focus())}}
          upload={(e) => this.onUpload('ApprovalLetter', e)}
          onClose={() => document.getElementById('PhysicianInfoButton').focus()}
        />
        <div className={"row"}>
          <div className=" col-12 col-sm-12  col-md-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 pt-2">
            <main id="main-content" tabIndex={-1} aria-label={this.props.t("Vaccine Records")}>
              <div className="card mt-2">
                <div className="card-header verlag-bold">
                  <h4 className='m-0'>{this.props.t("Vaccine Exemption Form")}</h4>
                </div>
                <div className="card-body">
                  <div className="form-group row col-12 mx-auto mx-sm-0" data-toggle={'tooltip'} data-placement={'top'} title={this.props.t('Type Of Exemption')}>
                    <label id={'TypeOfExemptionLabel'} htmlFor={'TypeOfExemption'} className="col-12 col-sm-4 col-form-label text-left px-2">{this.props.t('Type Of Exemption')}</label>
                    <div className="col-12 col-sm-8 p-0 m-0 text-center text-md-left d-flex justify-content-center align-items-center" id={'Type Of Exemption'}>
                      <Select
                        key={'TypeOfExemption'}
                        id={'TypeOfExemption'}
                        isSearchable={true}
                        aria-label={getReactSelectAriaLabel("Type of Exemption", this.state.ExemptionType ? getLabel(this.state.ExemptionType, this.state.exemptionTypes, this.props.t) : null, this.props.t)}
                        placeholder={<div className="accessibilityText">{this.props.t("Please Select...")}</div>}
                        noOptionsMessage={() => this.props.t("No option")}
                        value={this.state.ExemptionType ? getLabel(this.state.ExemptionType, this.state.exemptionTypes, this.props.t) : null}
                        onChange={(e) => {

                          this.setState((prevState) => ({
                            ExemptionType: e.value,
                            Immunizations: "",
                            ObjectionSummary: "",
                            ContraImmunizations: [],
                            duplicateCheckPassed: false,
                          }), () => {
                            // Trigger duplicate check if child info is already saved
                            if (this.state.childInfoSaved && this.state.childInfo?.ChildFirstName) {
                              this.triggerDuplicateCheck(this.state.childInfo, e.value);
                            }
                          })
                        }}
                        className={'state_select w-100'}
                        options={translationExemptionTypes}
                      />
                    </div>
                  </div>
                  {this.state.ExemptionType === 5 ? (<>
                    <p className='text-danger text-center'>All Medical Exemptions require the approval of a licensed Physician. Further information and direction is contained within the below <i>Physician Information</i> section</p>

                  </>) :
                    this.state.ExemptionType === 2 ?
                      (<>
                      </>) : this.state.ExemptionType === 1 ?
                        (<>
                          <div className="form-group row col-12 mx-auto mx-sm-0" data-toggle={'tooltip'} data-placement={'top'} title={this.props.t('Reason')}>
                            <label id={'ExemptionReason'} htmlFor={'ExemptionReason'} className="col-12 col-sm-4 col-form-label text-center text-md-left">{this.props.t('Reason')}</label>
                            <div className="col-12 col-sm-8 p-0 m-0 text-center text-md-left" id={'ExemptionReason'}>
                              <Select
                                key={'ExemptionReason'}
                                id={'ExemptionReason'}
                                isSearchable={true}
                                aria-label={getReactSelectAriaLabel("Reason", getLabel(this.state.ExemptionReason, this.state.exemptionReasons, this.props.t), this.props.t)}
                                placeholder={<div className="accessibilityText">{this.props.t("Please Select...")}</div>}
                                noOptionsMessage={() => this.props.t("No option")}
                                value={this.state.ExemptionReason ? getLabel(this.state.ExemptionReason, this.state.exemptionReasons, this.props.t) : null}
                                onChange={(e) => {
                                  this.setState((prevState) => ({
                                    ExemptionReason: e.value,
                                  }))
                                }}
                                className={'state_select'}
                                options={translationPersonalExemptionReasons}
                              />
                            </div>
                          </div>
                          {this.state.ExemptionReason === 7 ? <div className="form-group row col-12 mx-auto mx-sm-0" data-toggle={'tooltip'} data-placement={'top'} title={this.props.t("Summary of Objection")}>
                            <label id={"SummaryOfObjection"} htmlFor={"SummaryOfObjection"} className="col-12 col-sm-4 col-form-label text-left px-2">{this.props.t("Summary of Objection")}</label>
                            <div className="col-12 col-sm-8 p-0 m-0 text-center text-md-left d-flex justify-content-center align-items-center" id={"SummaryOfObjection"}>
                              <div className='w-100'>
                                <textarea
                                  className={"form-control mr-3"}
                                  maxLength={600}
                                  autoComplete={"off"}
                                  name={"SummaryOfObjection"}
                                  onChange={(e) => {
                                    this.setState((prevState) => ({
                                      ObjectionSummary: e.target.value
                                    }))
                                  }}
                                  value={this.state.ObjectionSummary}
                                />
                                <div className="row pt-1 pr-3 justify-content-end">
                                  <div className={this.state.ObjectionSummary && this.state.ObjectionSummary.length > 0 ? 'visible' : 'invisible'}>
                                    <div style={{ fontSize: '0.8em' }}>{this.state.ObjectionSummary && this.state.ObjectionSummary.length}/600</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> : <></>}
                        </>) : <></>
                  }
                  <hr />
                  <div className="form-group row col-12 mx-auto mx-sm-0" data-toggle={'tooltip'} data-placement={'top'} title={this.props.t("Select all Immunizations that this exemption applies to")}>
                    <label className="col-12 col-sm-4 col-form-label text-left px-2">{this.props.t("Select all Immunizations that this exemption applies to")}</label>
                    <div className="col-12 col-sm-8 p-0 m-0 text-center text-md-left d-flex justify-content-center align-items-center">
                      <Select
                        isMulti={true}
                        isSearchable={true}
                        placeholder={<div className="accessibilityText">{this.props.t("Please Select...")}</div>}
                        noOptionsMessage={() => this.props.t("No option")}
                        className={"state_select w-100"}
                        value={this.state.ExemptImmunizations ? this.state.ExemptImmunizations : null}
                        options={this.state.immunizationOptions}
                        onChange={(e) => {
                          let indexOfLastElement = e?.length - 1
                          //@ts-ignore
                          if (e && e[indexOfLastElement]?.value === 0) {
                            this.setState({ ExemptImmunizations: this.state.immunizations })
                          } else {
                            this.setState({ ExemptImmunizations: e })
                          }
                        }}
                        aria-label={getReactSelectAriaLabelMultiselect("Please select which Immunizations this exemption applies to:", this.state.ExemptImmunizations, this.props.t)}
                      />
                    </div>
                  </div>
                  {this.state.ExemptionType === 5 &&
                    (
                      <div className="card mb-2 mt-2">
                        <div className="card-header verlag-bold">
                          <div className="row">
                            <div className="col-8 col-sm-10">
                              <h4>{this.props.t("Physician Information")}</h4>
                            </div>
                            <div className="col-4 col-sm-2 d-flex justify-content-center align-items-center">
                              {this.state.physicianInfoSaved ?
                                <>
                                  <button
                                    id='PhysicianInfoButton'
                                    aria-label={this.props.t("Physician Information Review")}
                                    className={"btn btn-success verlag-bold"}
                                    style={{ float: 'right' }}
                                    onClick={() => showModalNoOutsideClick('Physicianinfo')}>
                                    {this.props.t("Review")}
                                  </button>
                                </>
                                :
                                <button
                                  id='PhysicianInfoButton'
                                  aria-label={this.props.t("Physician Information Start")}
                                  className={"btn btn-primary verlag-bold"}
                                  style={{ float: 'right' }}
                                  onClick={() => showModalNoOutsideClick('Physicianinfo')}>
                                  {this.props.t("Start")}
                                </button>
                              }

                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  <div className="mb-2">
                    <div className="card mt-2">
                      <div className="card-header verlag-bold">
                        <div className="row">
                          <div className="col-8 col-sm-10">
                            <h4>
                              {this.props.t("Child Information")}
                            </h4>
                          </div>
                          <div className="col-4 col-sm-2 d-flex justify-content-center align-items-center">
                            {this.state.childInfoSaved && this.state.childInfo ? (
                              <>
                                {/* <span className="float-right pl-2">
                                        <BsCheckCircle color={"#1E6111"} size={37} />
                                      </span> */}
                                <button
                                  id='ChildInfoButton'
                                  aria-label={this.props.t('Child Information Review')}
                                  className={"btn btn-success verlag-bold"}
                                  style={{ float: "right" }}
                                  onClick={() =>
                                    showModalNoOutsideClick("childinfo")
                                  }
                                >
                                  {this.props.t("Review")}
                                </button>
                              </>
                            ) : (
                              <button
                                id='ChildInfoButton'
                                aria-label={this.props.t('Child Information Start')}
                                className={"btn btn-primary verlag-bold"}
                                style={{ float: "right" }}
                                onClick={() =>
                                  showModalNoOutsideClick("childinfo")
                                }
                              >
                                {this.props.t("Start")}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="card mt-2">
                      <div className="card-header verlag-bold">
                        <div className="row">
                          <div className="col-8 col-sm-10">
                            <h4>
                              {this.props.t("Parent/ Guardian Information")}
                            </h4>
                          </div>
                          <div className="col-4 col-sm-2 d-flex justify-content-center align-items-center">
                            {this.state.parentInfoSaved ? (
                              <>
                                {/* <span className="float-right pl-2">
                                        <BsCheckCircle color={"#1E6111"} size={37} />
                                      </span> */}
                                <button
                                  id='ParentInfoButton'
                                  aria-label={this.props.t('Parent/ Guardian Information Review')}
                                  className={"btn btn-success verlag-bold"}
                                  style={{ float: "right" }}
                                  onClick={() =>
                                    showModalNoOutsideClick('parentinfo')
                                  }
                                >
                                  {this.props.t("Review")}
                                </button>
                              </>
                            ) : (
                              <button
                                id='ParentInfoButton'
                                aria-label={this.props.t('Parent/ Guardian Information Start')}
                                className={"btn btn-primary verlag-bold"}
                                style={{ float: "right" }}
                                onClick={() =>
                                  showModalNoOutsideClick('parentinfo')
                                }
                              >
                                {this.props.t("Start")}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="card mt-2">
                      <div className="card-header verlag-bold">
                        <div className="row">
                          <div className="col-8 col-sm-10">
                            <h4>
                              {this.props.t("School/ Child Care Information")}
                            </h4>
                          </div>
                          <div className="col-4 col-sm-2 d-flex justify-content-center align-items-center">
                            {this.state.schoolInfoSaved ? (
                              <>
                                {/* <span className="float-right pl-2">
                                        <BsCheckCircle color={"#1E6111"} size={37} />
                                      </span> */}
                                <button
                                  id='SchoolInfoButton'
                                  aria-label={this.props.t('School/ Child Care Information Review')}
                                  className={"btn btn-success verlag-bold"}
                                  style={{ float: "right" }}
                                  onClick={() =>
                                    showModalNoOutsideClick("schoolinfo")
                                  }
                                >
                                  {this.props.t("Review")}
                                </button>
                              </>
                            ) : (
                              <button
                                id='SchoolInfoButton'
                                aria-label={this.props.t('School/ Child Care Information Start')}
                                className={"btn btn-primary verlag-bold"}
                                style={{ float: "right" }}
                                onClick={() =>
                                  showModalNoOutsideClick("schoolinfo")
                                }
                              >
                                {this.props.t("Start")}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Acknowledgement
                    onSubmit={() => { this.submitForm() }}
                    onAcknowledge={(bool) => { this.setState({ acknowledged: bool }) }}
                  />
                </div>
              </div>
            </main>

          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(VaccineExemptions);